// extracted by mini-css-extract-plugin
export default {"bg-dark":"Footer_bg-dark__+RYEk","footer":"Footer_footer__TL9Uz","btn":"Footer_btn__msRGE","btn-link":"Footer_btn-link__MJndh","bottom_footer":"Footer_bottom_footer__gR7pJ"};